import { useTranslation } from '../hooks/useTranslation';

function ErrorLoading({ error, loading }) {
  const { t } = useTranslation();

  return (
    <>
      {error && (
        <div className="alert alert-danger" role="alert">
          {t('common.error')}: {error}
        </div>
      )}
      {loading && (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t('common.loading')}</span>
          </div>
        </div>
      )}
    </>
  );
}

export default ErrorLoading;
